import * as React from 'react';
import { useEffect } from 'react';
import * as mapbox from 'mapbox-gl';
import { Marker as MarkerType } from '../../types/Marker';
import { useMarker } from '../../hooks/useMarker';
import { Popup } from './Popup';

export interface MarkerProps {
    marker: MarkerType;
    map: mapbox.Map;
    markerSize?: number;
    onMarkerCreate: (marker: mapbox.Marker) => any;
};

export const Marker: React.FunctionComponent<MarkerProps> = ({ marker: m, map, onMarkerCreate, markerSize = 25 }) => {
    const isClickable = !!(m.href && m.title);
    const marker = useMarker(map, m.position, isClickable, markerSize);

    useEffect(() => {
        if (marker) {
            onMarkerCreate(marker);
        }
    }, [marker]);

    return isClickable && marker ? (
        <Popup
            marker={marker}
            title={m.title}
            subtitle={m.subtitle}
            href={m.href}
            markerSize={markerSize}
        />
    ) : null;
};

Marker.displayName = 'Marker';
